// Cross-column lead selection on the Sales Pipeline page (Trello-style).
//
// Lives only for the lifetime of the /pipeline route — cleared on navigation
// away or on session start so the next visit starts clean.

import { create } from 'zustand';

export const usePipelineSelection = create((set, get) => ({
  // Map<leadId, { firstName, lastName, phone, _id }>
  selected: new Map(),
  toggle: (lead) => {
    const next = new Map(get().selected);
    const id = lead?._id;
    if (!id) return;
    if (next.has(id)) next.delete(id);
    else next.set(id, {
      _id: id,
      firstName: lead.firstName,
      lastName: lead.lastName,
      phone: lead.phone,
    });
    set({ selected: next });
  },
  clear: () => set({ selected: new Map() }),
  setMany: (leads) => {
    const next = new Map();
    for (const l of leads || []) {
      if (l?._id) {
        next.set(l._id, {
          _id: l._id,
          firstName: l.firstName,
          lastName: l.lastName,
          phone: l.phone,
        });
      }
    }
    set({ selected: next });
  },
  size: () => get().selected.size,
  ids: () => Array.from(get().selected.keys()),
  values: () => Array.from(get().selected.values()),
}));
